// useTabReturnRefresh — fires a callback when this page's tab becomes the
// ACTIVE tab again after being hidden. TabContent keeps every open tab
// mounted behind display:none, so one-shot useEffect loads never re-fire on
// tab switches — attach the returned ref to the page root element and pass a
// refetch callback to keep data current when the user returns to the tab.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function useTabReturnRefresh(onReturn) {
  const ref = useRef(null);
  const cbRef = useRef(onReturn);
  cbRef.current = onReturn;
  const wasVisibleRef = useRef(true);
  const { pathname } = useLocation();
  useEffect(() => {
    const visible = !!ref.current && ref.current.offsetParent !== null;
    if (visible && !wasVisibleRef.current) cbRef.current?.();
    wasVisibleRef.current = visible;
  }, [pathname]);
  return ref;
}
